import { TriangleAlert } from 'lucide-react'

import { cn } from '@/lib/cn'

export interface AuthErrorBannerProps {
  message: string
  className?: string
}

/** Sits directly above the form it belongs to, so the failure reads next to its cause. */
export function AuthErrorBanner({ message, className }: AuthErrorBannerProps) {
  return (
    <div
      role="alert"
      className={cn(
        'flex items-start gap-2.5 rounded-lg border border-danger bg-danger/10 px-3 py-2.5',
        'text-sm text-danger',
        className,
      )}
    >
      <TriangleAlert className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" />
      <span>{message}</span>
    </div>
  )
}
